/**
 * Composable para gerenciar carregamento progressivo de componentes
 * Prioriza conteúdo above-the-fold e carrega o resto progressivamente
 */
export const usePriorityLoading = () => {
  const { isMobile } = useLayout();

  // Prioridades de carregamento
  const aboveFoldLoaded = ref(false);
  const belowFoldCanLoad = ref(false);
  const belowFoldLowPriorityCanLoad = ref(false);

  const initializePriorityLoading = () => {
    // Above-the-fold já carrega imediatamente
    aboveFoldLoaded.value = true;

    // Below-the-fold em mobile: aguarda um tempo ou scroll
    if (isMobile.value) {
      // Estratégia 1: Timeout curto após mount (carregamento progressivo)
      setTimeout(() => {
        belowFoldCanLoad.value = true;
      }, 100); // 100ms após mount inicial

      // Estratégia 2: Carrega conteúdo de baixa prioridade depois
      setTimeout(() => {
        belowFoldLowPriorityCanLoad.value = true;
      }, 500); // 500ms após mount inicial

      // Estratégia 3: Se usuário rolar, carrega tudo imediatamente
      const handleScroll = () => {
        if (window.scrollY > 100) {
          belowFoldCanLoad.value = true;
          belowFoldLowPriorityCanLoad.value = true;
          window.removeEventListener('scroll', handleScroll);
        }
      };

      window.addEventListener('scroll', handleScroll, { passive: true });

      // Cleanup
      onUnmounted(() => {
        window.removeEventListener('scroll', handleScroll);
      });
    } else {
      // Desktop: carrega tudo imediatamente
      belowFoldCanLoad.value = true;
      belowFoldLowPriorityCanLoad.value = true;
    }
  };

  return {
    aboveFoldLoaded,
    belowFoldCanLoad,
    belowFoldLowPriorityCanLoad,
    initializePriorityLoading,
  };
};
